import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, LL_V_L, ModuleFE_MouseInteractivity, performAction, TS_Input } from '@nu-art/thunderstorm-frontend/index';
import './CreateDiscussionPopup.scss';
import { QToastContent } from '../../q-components/index.js';
import { ModuleFE_Message, ModuleFE_Topic } from '@nu-art/ts-messaging-frontend';
import { ModuleFE_Discussion } from '../../../_entity/discussion/index.js';
import { DiscussionType_Chat } from '@app/hcs-shared/_entity/discussion/consts';
import { CollectionEntityMapper } from '../../../entities/CollectionEntityMapper.js';
export class CreateDiscussionPopup extends ComponentSync {
    static defaultProps = {
        modules: [ModuleFE_Discussion, ModuleFE_Topic, ModuleFE_Message]
    };
    __onDiscussionsUpdated(...params) {
        switch (params[0]) {
            case 'update':
            case 'delete':
            case 'delete-multi':
                this.reDeriveState();
                break;
        }
    }
    __onMessagesUpdated(...params) {
        switch (params[0]) {
            case 'create':
                this.reDeriveState();
                break;
        }
    }
    renderNewDiscussionInput() {
        return _jsx(LL_V_L, { className: 'message__new_comment', children: this.shouldShowInput()
                ? _jsx(TS_Input, { type: 'text', placeholder: 'New discussion title...', value: this.state.newDiscussionTitle, onChange: value => this.reDeriveState({ newDiscussionTitle: value }), onKeyDown: async (ev) => {
                        let value = ev.currentTarget.value;
                        value = value.trim();
                        if (ev.key === 'Enter') {
                            //@ts-ignore - despite what typescript says, ev.target does have a blur function.
                            ev.target.blur();
                            await this.addDiscussion();
                            ev.stopPropagation();
                        }
                        if (ev.key === 'Escape') {
                            this.clearInput();
                            ev.stopPropagation();
                        }
                    } }, 'comment_msg')
                : _jsx(Button, { className: 'button_msg_add', variant: 'primary', onClick: () => this.reDeriveState({ newDiscussionTitle: '' }), children: "Create new discussion" }) });
    }
    clearInput = () => this.setState({ newDiscussionTitle: undefined });
    shouldShowInput = () => this.state.newDiscussionTitle?.length !== undefined;
    addDiscussion = async () => {
        if (this.state.busy) {
            this.logError('Can\'t add another discussion, popup is currently busy adding a discussion!!!');
            return;
        }
        const newTitle = this.state.newDiscussionTitle;
        if (!newTitle)
            return;
        this.setState({ busy: true });
        await performAction(async () => {
            const response = await ModuleFE_Discussion._v1.createNewDiscussion({
                toCreateTopic: {
                    type: this.getRelevantCollectionName(), //collection name
                    refId: this.props.refId
                },
                toCreateDiscussion: {
                    type: DiscussionType_Chat
                },
                toCreateMessage: {
                    type: 'text',
                    text: newTitle.trim()
                }
            }).executeSync();
            this.reDeriveState({
                busy: false
            });
            ModuleFE_Discussion.openDiscussions({ topicId: response.topic._id, discussionId: response.discussion._id });
            ModuleFE_MouseInteractivity.hide('pop-up');
        }, {
            type: 'toast',
            successContent: _jsx(QToastContent, { toastType: 'success', iconKey: 'v', content: `Discussion created Successfully` }),
            duration: 10000
        }, newTitle, true);
    };
    getRelevantEntity() {
        return CollectionEntityMapper.getEntityMapByEntityName(this.props.entityName);
    }
    getRelevantCollectionName() {
        return this.getRelevantEntity().type;
    }
    getEntityType() {
        return this.getRelevantEntity().entityName;
    }
    getEntityLabel() {
        const collectionName = this.getRelevantCollectionName();
        const dbObject = ModuleFE_Discussion.getReferencedObjectByCollectionRef(collectionName, this.props.refId);
        if (!dbObject)
            return `Error- can't find entity for entityName ${this.props.entityName}.`;
        return ModuleFE_Discussion.getLabelFromEntity(collectionName, dbObject);
    }
    render() {
        return _jsxs(LL_V_L, { className: 'create-discussion__content', children: [_jsxs(LL_V_L, { className: 'create-discussion__header', children: [_jsx("div", { className: 'entity-type', children: this.getEntityType() }), _jsx("div", { className: 'entity-label', children: this.getEntityLabel() })] }), this.renderNewDiscussionInput()] });
    }
}
//# sourceMappingURL=CreateDiscussionPopup.js.map